import { TWorkflowBaseStepDefinition } from '@commenda/types';
import {
  FieldRefSource,
  TDataSourceCall,
  TParamValue,
  TValueProvider,
} from '@commenda/types/src/workflow/dsl';
import {
  isParamValueArray,
  isParamValueObject,
  isParamValueProvider,
} from './helpers';
import { ObjectEditor } from './ObjectEditor';
import { ParamValueArrayEditor } from './ParamValueArrayEditor';
import { ParamValueTypeSwitcher } from './ParamValueTypeSwitcher';
import { ValueProviderEditor } from './ValueProviderEditor';

export const ParamValueEditor = ({
  value,
  onChange,
  steps = [],
  dataSources = [],
  allowedFieldRefSources,
}: {
  value: TParamValue;
  onChange: (v: TParamValue) => void;
  steps?: TWorkflowBaseStepDefinition[];
  dataSources?: TDataSourceCall[];
  allowedFieldRefSources?: FieldRefSource[];
}) => {
  const isProvider = isParamValueProvider(value);
  const isArray = isParamValueArray(value);
  const isObject = isParamValueObject(value);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <ParamValueTypeSwitcher value={value} onChange={onChange} />
      </div>

      {isProvider && (
        <ValueProviderEditor
          value={value as TValueProvider}
          onChange={onChange}
          steps={steps}
          dataSources={dataSources}
          allowedFieldRefSources={allowedFieldRefSources}
        />
      )}

      {isObject && (
        <ObjectEditor
          value={value as Record<string, TParamValue>}
          onChange={onChange}
          renderNestedParamValueEditor={(
            nestedKey,
            nestedValue,
            onNestedValueChange
          ) => (
            <ParamValueEditor
              value={nestedValue}
              onChange={(newValue) => onNestedValueChange(nestedKey, newValue)}
              steps={steps}
              dataSources={dataSources}
              allowedFieldRefSources={allowedFieldRefSources}
            />
          )}
        />
      )}
      {isArray && (
        <ParamValueArrayEditor
          value={value as TParamValue[]}
          onChange={onChange}
          renderNestedParamValueEditor={(idx, val, onUpdate) => (
            <ParamValueEditor
              value={val}
              onChange={(nv) => onUpdate(idx, nv)}
              steps={steps}
              dataSources={dataSources}
              allowedFieldRefSources={allowedFieldRefSources}
            />
          )}
        />
      )}
    </div>
  );
};
